import React, { MouseEvent, KeyboardEvent, useContext } from 'react'
import { DispatchContext, StateContext } from '../../contexts'
import symptoms from '../../symptoms.yml'
import { answerQuestion } from '../../actions'
import { Symptoms } from '../../Symptoms'
import clsx from 'clsx'

export function Buttons({ questionId }: { questionId: string }) {
  const state = useContext(StateContext)
  const dispatch = useContext(DispatchContext)

  const genericHandler = (points: number) => {
    dispatch(answerQuestion(points, questionId))
  }

  const clickHandler = (
    points: number,
    event: MouseEvent<HTMLButtonElement>
  ) => {
    genericHandler(points)
  }

  const keyUpHandler = (
    points: number,
    event: KeyboardEvent<HTMLButtonElement>
  ) => {
    switch (event.key) {
      case ' ':
      case 'Enter':
      case 'Spacebar':
        event.preventDefault()
        genericHandler(points)
        break
    }
  }

  return (
    <div className='ui vertical teal basic labeled icon fluid buttons'>
      {Object.entries(symptoms).map(([key, name]) => {
        const buttonValue = Symptoms[key as keyof typeof Symptoms]
        const isSelected = state[questionId] === buttonValue

        return (
          <button
            className={clsx('ui button')}
            key={key}
            onKeyUp={event => keyUpHandler(buttonValue, event)}
            onClick={(event: React.MouseEvent<HTMLButtonElement>) =>
              clickHandler(buttonValue, event)
            }
          >
            <i
              className={clsx('circle icon', isSelected ? 'check' : 'outline')}
            />
            {name}
          </button>
        )
      })}
    </div>
  )
}
